import { render, staticRenderFns } from "./QrLamps.vue?vue&type=template&id=1d4984c2&"
import script from "./QrLamps.vue?vue&type=script&lang=js&"
export * from "./QrLamps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports